<template>
  <div class="create-role-container">
    <h3>Créer un nouveau rôle</h3>

    <label for="roleName">Nom du rôle</label>
    <input id="roleName" type="text" v-model="roleName" placeholder="ex : SONDAGE_ADMIN" :class="{ error: hasError }"/>

    <div class="action">
      <button class="primary-button" @click="createRole"><i class="material-icons">add_box</i>&nbsp;Créer le rôle</button>
    </div>

    <p v-if="successMessage" class="success-msg">{{ successMessage }}</p>
    <p v-if="hasError" class="error-msg">Le nom du rôle est requis.</p>
  </div>
</template>


<script setup>
import { ref } from 'vue';
import apiClient from '@/api';
import { useUserStore } from '@/stores/userstore';

const userStore = useUserStore()

const roleName = ref('');
const hasError = ref(false);
const successMessage = ref('');

const createRole = async () => {
  hasError.value = false;
  successMessage.value = '';

  if (!roleName.value.trim()) {
    hasError.value = true;
    return;
  }

  try {
    // const response = await apiClient.post('create_group/', {
    //   name: roleName.value.trim()
    // });

    // emits('update_roles')
    await userStore.createRole(roleName.value.trim())
    successMessage.value = `Rôle "${roleName.value}" créé avec succès.`;
    roleName.value = '';
  } catch (error) {
    hasError.value = true;
    console.error('Erreur lors de la création du rôle :', error);
  }
};
</script>

<style scoped lang="scss">
.create-role-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background-color: $ice-blue;
  border: 1px solid $platinium;
  border-radius: 8px;
  padding: 2rem;
  max-width: 400px;
  margin: 1rem;

  h3 {
    margin: 0;
    font-size: 1.2rem;
    color: $dark-blue;
  }

  label {
    font-weight: 600;
    color: $orange;
  }

  input {
    padding: 0.5rem;
    border: 1px solid $platinium;
    border-radius: 6px;
    font-size: 1rem;
    outline: none;

    background-color: #fff;

    &.error {
      border-color: red;
    }
  }

  .action {
    display: flex;
    justify-content: flex-end;
  }

  .success-msg {
    color: #008000;
    font-size: 0.9rem;
  }

  .error-msg {
    color: red;
    font-size: 0.9rem;
  }
}
</style>
